import { QBox, QText } from '@captivateiq/quotient';

import type { Message, MessageButtonSpec } from '@captivateiq/assistant/types';

import { MessageButtonBar } from './MessageButtonBar';

type UserMessageProps = {
  message: Message;
  buttons?: MessageButtonSpec[];
};
export const UserMessage = ({ message, buttons = [] }: UserMessageProps) => {
  return (
    <>
      {buttons?.length > 0 && <MessageButtonBar align="right" buttons={buttons} />}
      <QBox
        sx={{
          alignItems: 'center',
          backgroundColor: 'primary.200',
          border: '1px solid',
          borderColor: 'primary.300',
          borderRadius: '8px',
          justifyContent: 'stretch',
          padding: '12px',
        }}
      >
        <QText
          sx={{
            color: 'primary.900',
            fontSize: '12px',
            fontWeight: 400,
            lineHeight: '20px',
          }}
        >
          {message.contents}
        </QText>
      </QBox>
    </>
  );
};
